export default __webpack_public_path__ + "static/media/program_list_img02.7b267ced.jpg";